import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { ThemeProvider } from "@/theme/ThemeContext";
import { ConsentProvider } from "@/consent/ConsentContext";
import { AdminProvider } from "@/admin/AdminContext";
import { RequireAdmin } from "@/admin/RequireAdmin";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import CookieBanner from "@/components/CookieBanner";
import Home from "@/pages/Home";
import Diensten from "@/pages/Diensten";
import ExpatHousing from "@/pages/ExpatHousing";
import Business from "@/pages/Business";
import Tarieven from "@/pages/Tarieven";
import Cases from "@/pages/Cases";
import OverOns from "@/pages/OverOns";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/Admin/AdminLogin";
import AdminDashboard from "@/pages/Admin/AdminDashboard";
import IntakeSelfService from "@/pages/Intake/SelfService";

function PublicShell({ children }) {
  return (
    <div className="App min-h-screen flex flex-col bg-background text-foreground">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <CookieBanner />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <ConsentProvider>
          <AdminProvider>
            <BrowserRouter>
              <ScrollToTop />
              <Routes>
                {/* Admin (no public chrome) */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route
                  path="/admin"
                  element={
                    <RequireAdmin>
                      <AdminDashboard />
                    </RequireAdmin>
                  }
                />

                {/* Public site */}
                <Route path="/" element={<PublicShell><Home /></PublicShell>} />
                <Route path="/diensten" element={<PublicShell><Diensten /></PublicShell>} />
                <Route path="/expat-housing" element={<PublicShell><ExpatHousing /></PublicShell>} />
                <Route path="/bedrijfspanden" element={<PublicShell><Business /></PublicShell>} />
                <Route path="/tarieven" element={<PublicShell><Tarieven /></PublicShell>} />
                <Route path="/dossiers" element={<PublicShell><Cases /></PublicShell>} />
                <Route path="/over-ons" element={<PublicShell><OverOns /></PublicShell>} />
                <Route path="/faq" element={<PublicShell><FAQ /></PublicShell>} />
                <Route path="/contact" element={<PublicShell><Contact /></PublicShell>} />
                <Route path="/intake/:token" element={<PublicShell><IntakeSelfService /></PublicShell>} />
                <Route path="/privacy" element={<PublicShell><Privacy /></PublicShell>} />
                <Route path="/cookies" element={<PublicShell><Cookies /></PublicShell>} />
                <Route path="/algemene-voorwaarden" element={<PublicShell><Terms /></PublicShell>} />
                <Route path="*" element={<PublicShell><NotFound /></PublicShell>} />
              </Routes>
              <Toaster position="top-right" richColors closeButton />
            </BrowserRouter>
          </AdminProvider>
        </ConsentProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
